<template>
    <div>
        <v-row>
            <v-col cols="10" md="5">
                <v-text-field
                    outlined
                    dense
                    v-model="search"
                    :label="'Search Case'"
                    prepend-inner-icon="mdi-magnify"
                    :disabled="data_log.count >= 2 || data_log.status == 'N'"
                ></v-text-field>
            </v-col>
            <v-col cols="2"
                ><v-btn fab small :disabled="search == ''" @click="get_data()"
                    ><v-icon>mdi-magnify</v-icon></v-btn
                ></v-col
            >

            <v-col
                cols="12"
                md="8"
                class="mar-t-30"
                v-if="data_main.length > 0"
            >
                <v-card>
                    <v-card-text>
                        <v-row> </v-row>

                        <div
                            v-for="(r, IndexCase) in data_main"
                            :key="IndexCase"
                        >
                            <hr class="mt-5" v-if="IndexCase > 0" />
                            <hr class="mb-5" v-if="IndexCase > 0" />
                            <v-row>
                                <v-col cols="9"
                                    ><v-chip
                                        small
                                        dense
                                        :color="
                                            r.special_status == 'uncontrol'
                                                ? 'red lighten-2'
                                                : 'blue lighten-2'
                                        "
                                    >
                                        {{ r.case_id + " - " + r.subcase }}
                                    </v-chip></v-col
                                >
                                <v-spacer></v-spacer>
                                <!--  -->
                                <v-col cols="3" class="text-right"
                                    ><v-switch
                                        class="mar-t-05"
                                        v-model="checkbox"
                                        :value="r.subcase_id"
                                        label=""
                                    ></v-switch
                                ></v-col>
                                <v-col
                                    class=" mar-t-25 caption font-weight-bold pb-0 pt-1 color-font-c-4"
                                    v-if="r.created_date"
                                    cols="12"
                                >
                                    วันที่เปิดงาน : {{ r.created_date }}
                                </v-col>
                                <v-col
                                    class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                    v-if="r.site_name"
                                    cols="12"
                                >
                                    <v-icon class="pr-1 pb-1" color="red" small
                                        >mdi-home</v-icon
                                    >{{ r.site_name }}
                                </v-col>

                                <v-col
                                    class="caption font-weight-bold pb-0 pt-1 color-font-c-3"
                                    v-if="r.site_address"
                                    cols="12"
                                >
                                    <v-icon class="pr-1 pb-1" color="red" small
                                        >mdi-home-map-marker</v-icon
                                    >{{ r.site_address }}
                                </v-col>

                                <v-col
                                    class="caption font-weight-bold pb-0 pt-0 color-font-c-2"
                                    v-if="r.case_title"
                                    cols="12"
                                >
                                    <v-chip
                                        color="white"
                                        class="mr-1"
                                        x-small
                                        dense
                                    >
                                        {{ r.project_name }}</v-chip
                                    >{{ r.case_title }}
                                    <br v-if="r.subcase_title" />
                                    <v-chip
                                        v-if="r.subcase_title"
                                        x-small
                                        color="purple lighten-4"
                                        >{{ r.subcase_title }}</v-chip
                                    >
                                </v-col>

                                <v-col
                                    class="caption font-weight-bold pb-0 pt-1 color-font-c-4"
                                    v-if="r.product_serial"
                                    cols="12"
                                >
                                    SN : {{ r.product_serial }}
                                </v-col>

                                <v-col
                                    class="caption font-weight-bold pb-0 pt-1 color-font-c-2"
                                    v-if="r.remark"
                                    cols="12"
                                >
                                    <v-icon class="pr-1 pb-1" small
                                        >mdi-chat-alert</v-icon
                                    >{{ r.remark }}
                                </v-col>
                                <v-col
                                    class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                >
                                    <div v-if="r.parts.length == 0">
                                        <p class="ma-0">
                                            <v-icon class="pr-1 pb-1" small
                                                >mdi-pound</v-icon
                                            >Checking
                                        </p>
                                    </div>
                                    <div
                                        v-else
                                        v-for="(part, i) in r.parts"
                                        :key="i"
                                    >
                                        <p
                                            class="ma-0"
                                            :style="
                                                part.status == 'Reserve'
                                                    ? 'color:#D500F9'
                                                    : 'color:#0097A7'
                                            "
                                        >
                                            <v-icon class="pr-1 pb-1" small
                                                >mdi-pound</v-icon
                                            >
                                            <span> {{ part.part_name }} </span>
                                            <span class="font-weight-light">{{
                                                part.part_description
                                            }}</span>
                                            <span v-if="part.ship_date != null">
                                                ( {{ part.ship_date_x }} )
                                            </span>
                                            <span
                                                class="ml-1"
                                                v-if="part.status == 'Reserve'"
                                            >
                                                *ใช้ Spare part ที่ศูนย์
                                            </span>
                                            <span v-else class="ml-1">
                                                {{ "*" + part.status }}
                                            </span>
                                        </p>
                                    </div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-row>
                            <v-col cols="12">
                                <v-progress-linear
                                    v-if="chk_save_data == true"
                                    indeterminate
                                    color="cyan"
                                ></v-progress-linear>
                                <v-btn
                                    v-if="chk_save_data == false"
                                    color="success"
                                    block
                                    @click="save()"
                                    :disabled="checkbox.length == 0"
                                    ><v-icon small class="mr-1"
                                        >mdi-content-save</v-icon
                                    >
                                    Save</v-btn
                                >
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-col>

            <v-col cols="12" md="8" v-if="data_log.logs.length > 0">
                <v-card>
                    <v-card-text>
                        <h3>Log Assign Case</h3>
                        <v-row
                            v-for="(row, index) in data_log.logs"
                            :key="index"
                            class="mar-t-10"
                        >
                            <v-col cols="12" class="mt-2">
                                <v-chip small>{{ index + 1 }}.</v-chip>
                                <v-chip small color="info" class="ml-1 mr-1">{{
                                    row.case_id + "-" + row.subcase
                                }}</v-chip>
                                <v-chip small class="ml-1">{{
                                    row.engineer_name + " " + row.created_date
                                }}</v-chip>
                                <br />
                                <b>{{ row.site_name }}</b>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_log()
    },
    computed: {
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_data() {
            let data = {
                searchcase: this.search,
            }
            await axios
                .post(url + "engineer/assigned-today/search", data, this.tk)
                .then((response) => {
                    if (response.data.status == "ok") {
                        this.data_main = response.data.cases
                        this.search = ""
                    } else {
                        this.$swal(response.data.message, {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    }
                })
        },
        async get_log() {
            await axios
                .get(url + "engineer/assigned-today/log", this.tk)
                .then((response) => {
                    this.data_log = response.data
                })
        },
        async save() {
            this.chk_save_data = true
            let send = {
                subcase_id: this.checkbox,
            }
            await axios
                .post(url + "engineer/assigned-today/save", send, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.chk_save_data = false
                    this.data_main = []
                    this.checkbox = []
                    this.get_log()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
        },
    },
    data() {
        return {
            tk: null,
            search: "",
            chk_save_data: false,
            checkbox: [],
            data_main: [],
            data_log: {
                logs: [],
                count: 0,
            },
            text: "Success, Your work has been saved",
        }
    },
}
</script>
